module.exports = __webpack_public_path__ + "static/media/sun.e8965b34.svg";